export default {
  coming_soon: "Coming Soon",
  selectAll: "Select All",
  assets: "Assets",
  new: "New",
  seeMore: "See More",
  download: "Download",
  cancel: "Cancel",
  confirm: "Confirm",
  cancelAction: "Cancel",
  back: "Back",
  analyst:"Analyst"
};
